import { some } from 'lodash';

export type MobileOS = 'ios' | 'android';

export class BrowserInfo {
  private static get platform() {
    // navigator is not available when rendered from the server.
    return global.navigator?.userAgent.toLowerCase() || '';
  }
  static get isIOS() {
    return some(['iphone', 'ipad', 'ipod'], (os) =>
      BrowserInfo.platform.includes(os),
    );
  }

  static get isAndroid() {
    return BrowserInfo.platform.includes('android');
  }

  static get isAndroidWebView() {
    return BrowserInfo.isAndroid && BrowserInfo.platform.includes('; wv)');
  }

  static get isMobile() {
    return (
      BrowserInfo.isIOS ||
      BrowserInfo.isAndroid ||
      /\bmobi\b|\bmobile\b|\bphone\b|\btablet\b/.test(BrowserInfo.platform)
    );
  }

  static get isDesktop() {
    return !BrowserInfo.isMobile;
  }

  static get mobileOS(): MobileOS | null {
    if (!BrowserInfo.isMobile) return null;
    if (BrowserInfo.isIOS) return 'ios';
    if (BrowserInfo.isAndroid) return 'android';
    return null;
  }

  static get isOSX() {
    return /mac/.test(BrowserInfo.platform);
  }
  static get isApple() {
    return BrowserInfo.isIOS || BrowserInfo.isOSX;
  }
}
